// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions} from '../../../configure/legal/duck';

import ConfigPages from '../ConfigPages';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    legalSetting: state.legalConfig.legalSetting,
    isFetching: state.legalConfig.isFetchingLegalSetting,
    isSavingLegalSetting: state.legalConfig.isSavingLegalSetting,
  }),
  (dispatch: Dispatch<any>) => bindActionCreators({...actions}, dispatch)
)(ConfigPages);
